import axios from 'axios';
// import { ErrorPopup } from '@/components/popups';
import router from '@/router';
import { isAuthenticated, refreshAxiosHeader, logout } from '@/auth';
import { resetExpInSec } from '@/service/token-info-service'
// import NProgress from 'nprogress';
// import cookies from 'vue-cookies'
// import '@/styles/nprogress.css'

export default function configure() {

  // axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

  /*
  NProgress.configure({
    showSpinner: false,
    minimum: 0.85,
    trickle: 0.05
  });
   */

  refreshAxiosHeader();

  axios.interceptors.request.use(request => {

    // NProgress.start();
    if (request.url != '/v1/auth/token/refresh')
      resetExpInSec()

    return request
  })

  createAxiosResponseInterceptor();

}

export const createAxiosResponseInterceptor = () => {
  axios.interceptors.response.use(
    response => {
      // NProgress.done();
      return response
    },
    error => {

      // NProgress.done();

      if (error.response.status == 401) {

        const subStatus = error?.response?.data?.httpSubStatus;
        const isLoginRequest = error.response.config.url === '/v1/auth/login';
        if (!isAuthenticated() || (subStatus !== undefined && (subStatus === '401.50' || subStatus === '401.100' || subStatus === '401.40')) || isLoginRequest) {
          return Promise.reject(error);
        }

        // var isRefreshTokenRequest = error.response.config.url == '/v1/auth/token/refresh'
        // if (isRefreshTokenRequest) {
          //TODO reset Vuex stores
          logout()
          router.push('/login')
          return Promise.reject(error);
        // }

        /*
        if (isAuthenticated()) {

          axios.interceptors.response.eject(interceptor);

          return refreshTokens().then(authHeader => {
            setAccessToken(authHeader.access_token);

            // Versuche mit neuer Authentifizierung den ursprünglichen Request zu wiederholen
            error.response.config.headers['Authorization'] = cookies.get('Authorization');
            return axios(error.response.config);

          }).finally(
            () => {
              createAxiosResponseInterceptor();
              // NProgress.done();
            }
          );
        }
         */
      }

      if (error.response.status == 500)
        // ErrorPopup.show({ error });
       return Promise.reject(error);

      return Promise.reject(error);
    }
  );
}
